<header-title [model]="headerTitle"></header-title>

<div class="row my-3">
    <div class="col">
        <button class="btn btn-primary" type="button" [routerLink]="['/question/questionbank/add']">Add New Question Bank</button>
    </div>
</div>

<section class="panel">
    <div class="row my-3">
        <div class="col col-md-6">
            <header class="panel-heading">
                <h3 class="panel-title text-gray-600">Existing Question Banks</h3>
            </header>
        </div>
        <div class="col col-md-6">
            <div class="row align-items-center">
                <div class="col col-md-2 text-right">
                    <label class=" control-label">Filter:</label>
                </div>
                <div class="col-md-10">
                    <form [formGroup]="filterForm" *ngIf="filterForm">
                        <input type="text" class="form-control filter-input" formControlName="filterText" placeholder="Start typing to filter list" />
                    </form>
                </div>
            </div>
        </div>
    </div>
    <div class="panel-body">
        <div class="table-responsive">
            <table class="table table-hover mb-none dark">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Nr Of Optional Questions</th>
                        <th class="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let questionBank of questionBankList;index as i">
                        <td>{{i+1}}</td>
                        <td>{{questionBank.name}}</td>
                        <td>{{questionBank.nrOptionalQuestions}}</td>
                        <td class="actions text-center">
                            <a [routerLink]="['/question', 'questionbank', questionBank.id]" class="mb-1 mt-1 mr-2 text-primary"><i class="fas fa-edit"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>
